import mate50pro from "../../../images/huawei-mate-50-pro.jpg";
import galaxyZfold from "../../../images/samsung-galaxy-z-fold4-5g.jpg";
import galaxyxcover6 from "../../../images/samsung-galaxy-xcover6-pro-r.jpg";
import nova10pro from "../../../images/huawei-nova-10-pro.jpg";

export const sliderData = [
	{
		id: 1,
		name: "Huawei Mate 50 Pro",
		desc: "Huawei Mate 50 series debuts with SD 8+ Gen 1, variable aperture camera ",
		img: mate50pro,
		price: 1200,
	},
	{
		id: 2,
		name: "Samsung Galaxy Z fold4",
		desc: "Huawei Mate X2, the new foldable flagship, boasts 8-inch FullView display when unfolded, and folds flawlessly.",
		img: galaxyZfold,
		price: 1200,
	},
	{
		id: 3,
		name: "Huawei Nove 10 Pro",
		desc: "HUAWEI nova 10 Pro, with Star Orbit Ring design, 7.88 mm thin body and the unique Starry Silver, it always shimmer in your hand.",
		img: nova10pro,
		price: 800,
	},
	{
		id: 4,
		name: "Samsung galaxy Xcover 6pro",
		desc: "latest model available online iiiiii",
		img: galaxyxcover6,
		price: 1200,
	},
];
